import React from "react";
import { useEffect } from "react";

const BlurredText = ({ blur = 4, children }) => {

    // ----------- for devlopers please comment this to use inspect element---------

    // useEffect(() => {
    //     const disableRightClick = (e) => {
    //         e.preventDefault();
    //     };

    //     const disableDevTools = (e) => {
    //         // F12
    //         if (e.keyCode === 123) {
    //             e.preventDefault();
    //         }

    //         // Ctrl+Shift+I / J / C / U
    //         if (
    //             (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
    //             (e.ctrlKey && e.key === "U")
    //         ) {
    //             e.preventDefault();
    //         }
    //     };

    //     document.addEventListener("contextmenu", disableRightClick);
    //     document.addEventListener("keydown", disableDevTools);

    //     return () => {
    //         document.removeEventListener("contextmenu", disableRightClick);
    //         document.removeEventListener("keydown", disableDevTools);
    //     };
    // }, []);
    // -----------------------------------------
    return (
        <div style={{ filter: `blur(${blur}px)` }}>
            {children}
        </div>
    );
};

export default BlurredText;
